import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientBase } from './http-client-base.service';

@Injectable({
  providedIn: 'root'
})
export class TipoCertificadoService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'tipo_certificado'); // La URL base para el servicio de lotes
  }

  getTipoCertificados(page: number, limit: number) {
    return this.get<any[]>({
      endpoint: `?page=${page}&limit=${limit}`,
      trackLoading: true // 👈 activa el loader global
    });
  }

}
